import type { CancellationReason, UserCancellationReason } from "./types";

export const CANCELLATION_REASONS: UserCancellationReason[] = [
  "too_expensive",
  "not_using_enough",
  "missing_features",
  "switching_competitor",
  "quality_not_good",
  "too_complicated",
  "other",
];

/** Reasons that skip the offer step and go directly to confirmation.
 *  Empty — all reasons now show the 40% discount offer. */
export const SKIP_OFFER_REASONS: CancellationReason[] = [];
